import {
  GetAccountingSystemInvoicesGroupedParams,
  IAccountingSystemInvoiceRepository,
  IGetAccountingSystemInvoicesGroupedRepositoryResponse,
} from "@/core/repositories/accounting";

export class GetAccountingSystemInvoicesGroupedUseCase {
  constructor(private readonly accountingSystemInvoiceRepository: IAccountingSystemInvoiceRepository) {}

  async execute(
    params: GetAccountingSystemInvoicesGroupedParams,
    refetch?: boolean
  ): Promise<IGetAccountingSystemInvoicesGroupedRepositoryResponse> {
    return this.accountingSystemInvoiceRepository.getAccountingSystemInvoicesGrouped(params, refetch);
  }
}
